<script>
import { optionsValidator } from "../validators/options-validator";

export default {
  name: "UsesOptions",
  props: {
    value: { type: [String, Number] },
    options: {
      type: [Array, Object],
      validator: optionsValidator
    },
    placeholder: String
  },
  computed: {
    computedOptions() {
      let options = [];
      if (this.options) {
        if (this.options.constructor !== Object) {
          options = this.options.map(option => {
            if (typeof option === "string" || typeof option === "number") {
              return {
                label: option,
                value: option
              };
            }

            return option;
          });
        } else {
          options = this.options.items.map(item => {
            return {
              label: item[this.options.optionLabel],
              value: item[this.options.optionValue]
            };
          });
        }

        if (this.searchable && this.searchText && this.searchText.length) {
          options = options.filter(option => {
            const matchesLabel =
              option.label
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) > -1;

            return option.subLabel
              ? matchesLabel ||
                  option.subLabel
                    .toLowerCase()
                    .indexOf(this.searchText.toLowerCase()) > -1
              : matchesLabel;
          });
        }
      }
      return options;
    },
    selectedOption: {
      get() {
        if (this.computedOptions) {
          return this.computedOptions.find(
            option => option.value === this.value
          );
        }
        return null;
      },
      set(val) {
        this.$emit("input", val ? val.value : null);
      }
    },
    selectedText() {
      if (this.value && this.selectedOption) {
        return this.selectedOption.label;
      }

      return this.placeholder;
    },
    selectedSubLabel() {
      return this.selectedOption &&
        this.selectedText &&
        this.selectedOption.subLabel
        ? this.selectedOption.subLabel
        : null;
    }
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    isSelectedOption(option) {
      return this.selectedOption && this.selectedOption.value === option.value;
    }
  }
};
</script>
